module.exports = __webpack_public_path__ + "static/media/IMG_4296.ca11fe96.PNG";